import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';

import PropTypes from 'prop-types';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/templates.actions';
import * as home from '../../../../actions/process.home.actions';
import * as actionsprocess from '../../../../actions/api.manage.process.actions';
import { get } from '../../../../api/_basic';

import TextField from '@material-ui/core/TextField';
import Hidden from '@material-ui/core/Hidden';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Mail from '@material-ui/icons/Mail';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import Snackbar from '../../../labels/Snackbar';
import DownshiftMultiple from '../../../inputs/MultipleInput';
import Editor from './Editor';
import Menu from '../Menu';
import Dialog from './DialogMail';
import DialogFields from './DialogFields';


import { BlueTickIcon } from '../../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_style.css';

function isOk(field) {
    return field === undefined || field.length < 2;
}

function helperText(field, intl) {
    return field === undefined || field.length === 0
        ? intl.formatMessage({ id: 'required' })
        : field.length < 2
            ? intl.formatMessage({ id: 'min_length_2' })
            : '';
}

function toolbar(handleSummit) {
    return (
        <BlueTickIcon
            key="submmit-post-template"
            className="hand"
            color="primary"
            onClick={handleSummit}
        />
    );
}
function types(id) {
    switch (id) {
        case 1:
            return 'rol';
        case 2:
            return 'user';
        case 3:
            return 'email';
        case 4:
            return 'generator';
        case 5:
            return 'variable';
        case 6:
            return 'nombre';
        default:
            return 'system';
    }
}

function idtypes(type) {
    switch (type) {
        case 'user':
            return 2;
        case 'rol':
            return 1;
        case 'email':
            return 3;
        case 'generator':
            return 4;
        case 'variable':
            return 5;
        case 'nombre':
            return 6;
        default:
            return 99;
    }
}

function isEmpty(obj) {
    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== 'object') return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
}


class Template extends React.Component {
    state = {
        id: undefined,
        nombre: '',
        template: undefined,
        plantillas: [],
        openFields: false,
        error: undefined,
        errorType: undefined
    };

    constructor(props) {
        super(props);
        props.loadManageProcesses();
        if (props.id) {
            props.loadTemplate(props.id);
        }

        this.loadTemplateFields(this.state.proceso);
        get(process.env.REACT_APP_API_MASTER + '/plantillapdf').then((data) => {
            this.setState({ plantillas: data ? data : [] });
        });
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    static getDerivedStateFromProps(props, state) {
        console.log(props.id);
        const { template, info, id } = props;
        if ((id && template !== state.template) || state.info !== info) {
            state.template = id ? template : {};
            state.nombre = id && template && template.nombre ? template.nombre : '';
            state.asunto = id && template && template.asunto ? template.asunto : '';
            state.a =
                id && template && template.a
                    ? template.a.map((e) => {
                        return {
                            name: e.auxiliar,
                            id: e.principal,
                            type: types(e.tipo),
                            key: randomstring(),
                        };
                    })
                    : [];
            state.cc =
                id && template && template.cc
                    ? template.cc.map((e) => {
                        return {
                            name: e.auxiliar,
                            id: e.principal,
                            type: types(e.tipo),
                            key: randomstring(),
                        };
                    })
                    : [];
            state.bcc =
                id && template && template.bcc
                    ? template.bcc.map((e) => {
                        return {
                            name: e.auxiliar,
                            id: e.principal,
                            type: types(e.tipo),
                            key: randomstring(),
                        };
                    })
                    : [];
            state.adjuntar = id && template && template.adjuntar ? template.adjuntar : undefined;
            state.cuerpo = id && template && template.cuerpo ? template.cuerpo : '';
            state.familiaProceso =
                id && template && template.familiaProceso ? template.familiaProceso : undefined;
            state.proceso = id && template && template.proceso ? template.proceso : undefined;
            state.de =
                id && template && (template.deAuxiliar || template.dePrincipal || template.deTipo)
                    ? [
                        {
                            name:
                                template && template.deAuxiliar ? template.deAuxiliar : undefined,
                            id:
                                template && template.dePrincipal
                                    ? template.dePrincipal
                                    : undefined,
                            type: types(
                                template && template.deTipo ? types(template.deTipo) : undefined,
                            ),
                            key: randomstring(),
                        },
                    ]
                    : [];
            state.suggestions = info && info.security ? info.security.destinatarios : undefined;
            state.info = info;
            return state;
        }

        return null;
    }

    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    updateHandle = (state) => {
        console.log(state);
        if (this.state.processfound !== state.proceso) {
            this.loadTemplateFields(state.proceso);
        }

        if (this.isCorrect(state)) {
            const tools = [toolbar(this.handleSummit)];
            this.props.setTools(tools);
        } else {
            this.props.setTools([]);
        }
    };

    getDirection = (arr) => {
        return arr.reduce((found, item) => {
            if (item.campos) {
                found = found.concat(this.getDirection(item.campos));
            }
            if (item.hijos) {
                found = found.concat(this.getDirection(item.hijos));
            }
            if (item.direccion) {
                found.push({
                    name: item.nombre,
                    id: item.codigo,
                    type: 'variable',
                    key: randomstring(),
                });
            }
            return found;
        }, []);
    };

    loadTemplateFields = (proceso) => {
        get(process.env.REACT_APP_API_TEMPLATE_FIELDS + (proceso ? '/' + proceso : '')).then((data) => {
            const { info } = this.state;
            let suggestions = info && info.security ? info.security.destinatarios : [];
            const directions = this.getDirection(data);
            suggestions = suggestions.concat(directions);
            this.setState({
                fields: data ? data : [],
                processfound: proceso,
                suggestions: suggestions,
            });
        });
    };

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleChange = (event) => {
        const state = this.state;
        state[event.target.name] = event.target.value;
        this.updateHandle(state);
        this.setState(state);
    }

    handleChangeEditor = (html, delta, source) => {
        console.log(html);
        if (source === 'user') {
            const state = this.state;
            state['asunto'] = html;
            this.updateHandle(state);
            this.setState(state);
        }
    };

    handleUpdate = (name, values) => {
        this.handleChange({ target: { name: name, value: values } });
    };

    handleOpenEmail = (destination) => (event) => {
        this.setState({ email: destination });
    };

    isCorrect = (state) => {
        const { nombre, asunto, a, bcc } = state;
        return (
            nombre &&
            nombre.length > 1 &&
            asunto &&
            asunto.length > 0 &&
            ((a && a.length > 0) || (bcc && bcc.length > 0))
        );
    }

    handleCloseWarning = () => {
        this.setState({ error: undefined, errorType: undefined });
    }

    handleClose = (value) => {

        if (value) {
            const { suggestions, email } = this.state;

            const arr = this.state[email];
            const element = { name: value, id: undefined, type: 'email', key: randomstring() };
            arr.push(element);
            suggestions.push(element);
            this.setState({
                error: undefined,
                email: undefined,
                suggestions: suggestions,
                [email]: arr,
            });
        } else {
            this.setState({ error: undefined, email: undefined });
        }
    }

    

    handleSummit = () => {
        const {
            nombre,
            asunto,
            adjuntar,
            cuerpo,
            familiaProceso,
            proceso,
            de,
            a,
            cc,
            bcc,
        } = this.state;
        const template = {
            nombre: nombre,
            asunto: asunto,
            adjuntar: adjuntar ? adjuntar : null,
            cuerpo: cuerpo,
            familiaProceso: familiaProceso && proceso ? familiaProceso : '',
            proceso: proceso && familiaProceso ? proceso : '',
            deAuxiliar: de && de.length > 0 ? de[0].name : undefined,
            dePrincipal: de && de.length > 0 ? de[0].id : undefined,
            deTipo: de && de.length > 0 ? idtypes(de[0].type) : undefined,
            a: a
                ? a.map((e) => {
                    return { auxiliar: e.name, principal: e.id, tipo: idtypes(e.type) };
                })
                : [],
            cc: cc
                ? cc.map((e) => {
                    return { auxiliar: e.name, principal: e.id, tipo: idtypes(e.type) };
                })
                : [],
            bcc: bcc
                ? bcc.map((e) => {
                    return { auxiliar: e.name, principal: e.id, tipo: idtypes(e.type) };
                })
                : [],
        };

        if (!this.props.id) {
            this.props
                .addTemplate(template)
                .then((r) => {
                    this.props.history.push('/manage/templates');
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ error: error.message, errorType: error.type });
                });
        } else {
            template.id = this.props.id;
            this.props
                .editTemplate(template)
                .then((r) => {
                    this.props.history.push('/manage/templates');
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ error: error.message, errorType: error.type });
                });
        }
    }


    handleShowFields = () => {
        console.log('Index handleShowFields');
        this.setState({ openFields: true, range: this.reactQuillRef.getEditor().getSelection() });
    }

    handleCloseFields = (item, type) => {
        if (item) {
            const index = this.state.range ? this.state.range.index : 0;
            const length = this.state.range ? this.state.range.length : 0;
            this.reactQuillRef.getEditor().deleteText(index, length);
            this.reactQuillRef
                .getEditor()
                .insertEmbed(
                    index,
                    type,
                    { value: item.nombre.toUpperCase(), id: item.codigo },
                    'user',
                );
        }
        this.setState({ openFields: undefined });
    };

    render() {
        const {
            nombre,
            asunto,
            error,
            errorType,
            de,
            a,
            cc,
            bcc,
            suggestions,
            cuerpo,
            familiaProceso,
            proceso,
            fields,
            template,
            plantillas,
            email,
            openFields
        } = this.state;

        const { intl, id, info, templates_has_errored, manage_process } = this.props;
        const processes =
            manage_process && familiaProceso && manage_process.families
                ? manage_process.families.find((f) => f.nombre === familiaProceso)
                : undefined;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '62') &&
              info.security.licencias.some((f) => f.id === 151 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else if (id && templates_has_errored.hasErrored && templates_has_errored.error) {
            return (
                <Error open type={templates_has_errored.hasErrored}  message={templates_has_errored.error} handleClose={this.handleBack} />
            );
        } else if (!id || (id && !isEmpty(template))) {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    {error && (
                        <Snackbar
                            open={true}
                            variant={ errorType ?  errorType : "error" }
                            text={error}
                            onClose={this.handleCloseWarning}
                        />
                    )}
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white showbar'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={2} />
                        </div>
                    </Hidden>
                    <div className={'flex_full bg_white'}>
                        <div className={'flex_full_column padding_bottom_9 height100'}>
                            <div
                                className="flex_full overflow_y_scroll showbar "
                                onScroll={this.handleScroll}
                            >
                                <div className="flex_full_column padding_borders_flat">
                                    <TextField
                                        fullWidth
                                        id={'nombre'}
                                        name={'nombre'}
                                        error={isOk(nombre)}
                                        helperText={helperText(nombre, intl)}
                                        label={intl.formatMessage({ id: 'form_field_name_nombre' })}
                                        className={'flex_full_row'}
                                        value={nombre}
                                        onChange={this.handleChange}
                                        margin="normal"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                                <div className="flex_full_column padding_borders_flat">
                                    <div className="barlow_regular_smalltext c_slate_grey text_align_left">
                                        {intl.formatMessage({ id: 'form_field_name_de' })}
                                    </div>
                                    <div className="flex_full_row center">
                                        <div className="flex_full_row">
                                            <DownshiftMultiple
                                                id="de_selection"
                                                label={intl.formatMessage({
                                                    id: 'form_field_user_roles_hierarchies',
                                                })}
                                                suggestions={suggestions}
                                                value={de}
                                                name="de"
                                                onChange={this.handleUpdate}
                                            />
                                        </div>
                                        <div className="flex_auto_row">
                                            <Mail
                                                className=" c_bluish hand"
                                                onClick={this.handleOpenEmail('de')}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex_full_column padding_borders_flat">
                                    <div className="barlow_regular_smalltext c_slate_grey text_align_left">
                                        {intl.formatMessage({ id: 'form_field_name_a' })}
                                    </div>
                                    <div className="flex_full_row center">
                                        <div className="flex_full_row">
                                            <DownshiftMultiple
                                                id="a_selection"
                                                label={intl.formatMessage({
                                                    id: 'form_field_user_roles_hierarchies',
                                                })}
                                                suggestions={suggestions}
                                                value={a}
                                                name="a"
                                                onChange={this.handleUpdate}
                                            />
                                        </div>
                                        <div className="flex_auto_row">
                                            <Mail
                                                className=" c_bluish hand"
                                                onClick={this.handleOpenEmail('a')}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex_full_column padding_borders_flat">
                                    <div className="barlow_regular_smalltext c_slate_grey text_align_left">
                                        {intl.formatMessage({ id: 'form_field_name_cc' })}
                                    </div>
                                    <div className="flex_full_row center">
                                        <div className="flex_full_row">
                                            <DownshiftMultiple
                                                id="cc_selection"
                                                label={intl.formatMessage({
                                                    id: 'form_field_user_roles_hierarchies',
                                                })}
                                                suggestions={suggestions}
                                                value={cc}
                                                name="cc"
                                                onChange={this.handleUpdate}
                                            />
                                        </div>
                                        <div className="flex_auto_row">
                                            <Mail
                                                className=" c_bluish hand"
                                                onClick={this.handleOpenEmail('cc')}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex_full_column padding_borders_flat">
                                    <div className="barlow_regular_smalltext c_slate_grey text_align_left">
                                        {intl.formatMessage({ id: 'form_field_name_bcc' })}
                                    </div>
                                    <div className="flex_full_row center">
                                        <div className="flex_full_row">
                                            <DownshiftMultiple
                                                id="bcc_selection"
                                                label={intl.formatMessage({
                                                    id: 'form_field_user_roles_hierarchies',
                                                })}
                                                suggestions={suggestions}
                                                value={bcc}
                                                name="bcc"
                                                onChange={this.handleUpdate}
                                            />
                                        </div>
                                        <div className="flex_auto_row">
                                            <Mail
                                                className=" c_bluish hand"
                                                onClick={this.handleOpenEmail('bcc')}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex_full_column padding_borders_flat">
                                    <InputLabel className="margin_bottom_12 barlow_regular_smalltext" >
                                        {intl.formatMessage({ id: 'form_field_name_asunto' })}
                                    </InputLabel>
                                    <div className="boxBorder subject">
                                        {/*
                                        <CustomToolbar onClickRaw={this.handleShowFields} />
                                        <ReactQuill
                                            ref={(el) => {
                                                this.reactQuillRef = el;
                                            }}
                                            theme={''}
                                            onChange={this.handleChangeEditor}
                                            onBlur={this.handleBlur}
                                            defaultValue={asunto}
                                            bounds={'.app'}
                                            placeholder={this.props.placeholder}
                                        />
                                        */}
                                        <Editor
                                            {...this.props}
                                            id={randomstring()}
                                            name="asunto"
                                            value={asunto}
                                            fields={fields}
                                            onChange={this.handleChange}
                                            min={true}
                                        />
                                    </div>
                                    {openFields && <DialogFields 
                                                        {...this.props} 
                                                        fields={fields}
                                                        onClose={this.handleCloseFields} 
                                                        />
                                    }
                                </div>
                                <div className="flex_full_column padding_borders_flat">
                                    <FormControl
                                        required
                                        className={
                                            'flex_full width100 barlow_regular_subtitle c_slate'
                                        }
                                    >
                                        <InputLabel htmlFor="age-native-simple" shrink>
                                            {intl.formatMessage({
                                                id: 'form_field_name_templates',
                                            })}
                                        </InputLabel>
                                        <Select
                                            native
                                            value={this.state.adjuntar}
                                            onChange={this.handleChange}
                                            inputProps={{
                                                name: 'adjuntar',
                                                id: 'adjuntar-simple',
                                            }}
                                        >
                                            <option key={randomstring()} value={undefined} />
                                            {plantillas &&
                                                plantillas.map((cat) => {
                                                    return (
                                                        <option
                                                            key={randomstring()}
                                                            className="upper"
                                                            value={cat.id}
                                                        >
                                                            {cat.nombre.toUpperCase()}
                                                        </option>
                                                    );
                                                })}
                                        </Select>
                                    </FormControl>
                                </div>

                                <div className="flex_full_column padding_borders_flat">
                                    <FormControl
                                        className={
                                            'flex_full width100 barlow_regular_subtitle c_slate'
                                        }
                                    >
                                        <InputLabel htmlFor="age-native-simple" className="" shrink>
                                            {intl.formatMessage({ id: 'family' })}
                                        </InputLabel>
                                        <Select
                                            native
                                            value={familiaProceso}
                                            onChange={this.handleChange}
                                            inputProps={{
                                                name: 'familiaProceso',
                                                id: 'familiaProceso-id',
                                            }}
                                            className="upper"
                                        >
                                            <option key={randomstring()} value={undefined} />
                                            {manage_process &&
                                                manage_process.families &&
                                                manage_process.families
                                                    .sort((a, b) => (a.nombre < b.nombre ? -1 : 1))
                                                    .map((f) => {
                                                        return (
                                                            <option
                                                                key={randomstring()}
                                                                className="upper"
                                                                value={f.nombre}
                                                            >
                                                                {f.nombre.toUpperCase()}
                                                            </option>
                                                        );
                                                    })}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="flex_full_column padding_borders_flat">
                                    <FormControl
                                        className={
                                            'flex_full width100 barlow_regular_subtitle c_slate'
                                        }
                                    >
                                        <InputLabel htmlFor="age-native-simple" className="" shrink>
                                            {intl.formatMessage({ id: 'process' })}
                                        </InputLabel>
                                        <Select
                                            native
                                            value={proceso}
                                            onChange={this.handleChange}
                                            inputProps={{ name: 'proceso', id: 'proceso-id' }}
                                            className="upper"
                                        >
                                            <option key={randomstring()} value={undefined} />
                                            {processes &&
                                                processes.processes &&
                                                processes.processes
                                                    .sort((a, b) => (a.nombre < b.nombre ? -1 : 1))
                                                    .map((f) => {
                                                        return (
                                                            <option
                                                                key={randomstring()}
                                                                className="upper"
                                                                value={f.codigo}
                                                            >
                                                                {f.nombre.toUpperCase()}
                                                            </option>
                                                        );
                                                    })}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="flex_full_column padding_borders_flat">
                                    <Editor
                                        {...this.props}
                                        id={randomstring()}
                                        name="cuerpo"
                                        value={cuerpo}
                                        fields={fields}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {email && <Dialog {...this.props} onClose={this.handleClose} />}
                </div>
            );
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    <Loading open opacity />
                    {error && (
                        <Snackbar
                            open={true}
                            variant={ errorType ? errorType : "error" }
                            text={error}
                            onClose={this.handleCloseWarning}
                        />
                    )}
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_40 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_ice_blue'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={2} />
                        </div>
                    </Hidden>
                    <div className={'flex_60 center bg_white'} />
                </div>
            );
        }
    }
}

Template.propTypes = {
    intl: intlShape.isRequired,
    template: PropTypes.object.isRequired,
    templates_has_errored: PropTypes.object.isRequired,
    templates_is_loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    return {
        templates_has_errored: state.templates_has_errored,
        templates_is_loading: state.templates_is_loading,
        template: state.template,
        manage_process: state.manage_process,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home, actionsprocess), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(injectIntl(Template)));



// WEBPACK FOOTER //
// ./src/components/complex/manage/template/Index.js